import React, { useCallback } from 'react';
import format from 'date-fns/format';
import { TableRow, TableCell, Pagination } from '@unimed-fesp/components';

import EmptyContent from '../../molecules/EmptyContent';

const TableHistoricoHeader = ({
  paginationParams,
  historicoAlteracoes,
  setPaginationParams,
}) => {
  const handleChangePage = useCallback(
    (paramsPgs) => {
      setPaginationParams({
        ...paramsPgs,
      });
    },
    [setPaginationParams]
  );

  const handlePageChangeKeyDown = useCallback(
    (e) => {
      if (e.keyCode === 13 && paginationParams.pageNumber !== '')
        setPaginationParams({
          ...paginationParams,
        });
    },
    [paginationParams, setPaginationParams]
  );

  if (historicoAlteracoes && historicoAlteracoes.length <= 0)
    return (
      <TableRow>
        <TableCell colSpan={6}>
          <EmptyContent />
        </TableCell>
      </TableRow>
    );

  const historicoAlteracoesPag = [...historicoAlteracoes].splice(
    (paginationParams.pageNumber - 1) * paginationParams.pageSize,
    paginationParams.pageSize
  );

  return (
    <>
      {historicoAlteracoesPag.map((alteracao) => (
        <TableRow>
          <TableCell maxWidth={300} minWidth={150}>
            {alteracao.nome || '-'}
          </TableCell>
          <TableCell maxWidth={300} minWidth={150}>
            {alteracao.descricao || '-'}
          </TableCell>
          <TableCell maxWidth={300} minWidth={150}>
            {alteracao.statusDescricao || '-'}
          </TableCell>
          <TableCell maxWidth={300} minWidth={150}>
            {alteracao.dtAlteracao
              ? format(new Date(alteracao.dtAlteracao), 'dd/MM/yyyy HH:mm', {
                  timeZone: 'America/Sao_Paulo',
                })
              : '-'}
          </TableCell>
        </TableRow>
      ))}
      <TableRow>
        <TableCell colSpan={7}>
          <Pagination
            total={historicoAlteracoes.length}
            paginationParams={paginationParams}
            setPaginationParams={setPaginationParams}
            handlePageChangeKeyDown={handlePageChangeKeyDown}
            callbackChangePage={handleChangePage}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableHistoricoHeader;
